import {
  LogoutOutlined,
  UserOutlined
} from "@ant-design/icons";
import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import {LoginContext} from '../../Helper/Context';

import canesuggar from '../../images/image-4.svg';
//import UserProfile from '../UserProfile';

import { useGoogleLogin } from "@react-oauth/google";

import './header.css';

function Header() {

  const  {loggedIn, setLoggedIn} = useContext(LoginContext);

  //const [user, setUser] = useState([]);

  const [click, setClick] = useState(false);
  //const [button, setButton] = useState(true);
  const [isMobile, setisMobile] = useState(false);
  //const clientID ="1011380741357-uerjvrt51l3fvfkj44mh9ao14fva1gjl.apps.googleusercontent.com";
  const clientID ="1000325475730-cm4enk5lsvpbnipv006sqnm3dhik0kqi.apps.googleusercontent.com";

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const navigate = useNavigate();
  
  const showButton = () => {
    if (window.innerWidth <= 960) {
      //setButton(false);
      setisMobile(true);
    } else {
      setisMobile(false);
      //setButton(true);
    }
  };

 /* useEffect(() => {
    if (typeof user.access_token!=='undefined') {
      fetch(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
        headers: {
          Authorization: `Bearer ${user.access_token}`,
          Accept: "application/json",
        }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(async(data) => {
          
          try {
            const tokenId = data.id;
      
            const res = await fetch('/auth/login', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({'googleId':data.id}),
            });
            
            if (res.ok) {
      
              const monCanHeaderValue = res.headers.has('Mon-Can');
      
              if (monCanHeaderValue !== false) {
                return res.json().then(cultivos => {
                  console.log(data);
                  setLoggedIn({
                    id: tokenId,
                    name: data.given_name,
                    isAuthenticated: true,
                    mainCrop:cultivos[0].id??''
                  });
        
                  if(cultivos.length>0){
                    navigate('/farmer/'+cultivos[0].id);
                  }
                });          
              }else {
                alert('EL usuario no está registrado')
              }
            }else {
              alert('EL usuario no está registrado')
            }
          } catch (error) {
            console.error('Error:', error);
          }

          //setLoggedIn(data);
        })
        .catch(error => {
          console.error('There was a problem with the fetch operation:', error);
        });
    }
    
    showButton();
  }, [user,clientID]);

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      setUser(codeResponse)
      console.log(codeResponse)
    },
    onError: (error) => console.log("Login Failed:", error)
  });*/

  const data = {
    given_name : 'Hugo',
  }
  const  login = async() => {

            const tokenId = '101622218087188103562';
      
            const res = await fetch('/api/auth/login', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({'googleId':'101622218087188103562'}),
            });
            
            if (res.ok) {
      
              const monCanHeaderValue = res.headers.has('Mon-Can');
      
              if (monCanHeaderValue !== false) {
                return res.json().then(cultivos => {
                  console.log(data);
                  setLoggedIn ({
                    id: tokenId,
                    name: data.given_name,
                    isAuthenticated: true,
                    mainCrop:cultivos[0].id??''
                  });
        
                  if(cultivos.length>0){
                    navigate('/farmer/'+cultivos[0].id);
                  }
                });          
              }else {
                alert('EL usuario no está registrado')
              }
            }else {
              alert('EL usuario no está registrado')
            }
          } 

  

  const signOut = () => {
    setLoggedIn(false);
    navigate('/');
  };  

  window.addEventListener('resize', showButton);

  return (
    <>
      {loggedIn && isMobile && (
        <div id="authBar">                  
          <span>Bienvenido, {loggedIn.name}</span>
          <span className="has-cursor-pointer" onClick={signOut}><LogoutOutlined /> </span>
        </div>
      )}
      <nav className='navbar'>
        <div className='navbar-container'>
          <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
            Monitor
            <img src={canesuggar} alt='logo' style={{ width: '60px', height: '50px' }} />
          </Link>

          <div className='menu-icon' onClick={handleClick}>
            <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
          </div>
          <div>
          
          </div>

          <ul className={`nav-menu ${click ? 'active' : ''} ${isMobile ? 'is-mobile' : ''}`} onClick={() => setClick(!click)}>
            <li className='nav-item'>
              <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                Inicio
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/contact'
                className='nav-links'
                onClick={closeMobileMenu}
              >Contacto
              </Link>
            </li>
            {loggedIn && !isMobile &&(
              <li className="nav-item" id="authBar">                  
                <Link className="nav-links" to={'/farmer/'+loggedIn.mainCrop}><UserOutlined />{loggedIn.name}</Link>
              </li>
            )}
              {!loggedIn && (
              <li className="nav-item1">

              <button
              type="button"
              className="bubble"
              onClick={() => login()}
            >
              Entrar
            </button>

              </li>
              )}
              {loggedIn && !isMobile &&(
              <li className="nav-item" id="authBar">
                <a href="/" className="nav-links" onClick={signOut} style={{cursor:'pointer'}}><LogoutOutlined /> </a>
              </li>
              )}
            </ul>
        </div>
      </nav>
    </>
  );
}

export default Header;